import {
  IResvMultiRm,
  resvPdProps,
  resvRmProps,
  rmOpProps,
  searchRmProps,
  selRmListProps,
} from "interface/book";
import api from "./api";

//객실정보 조회
export const searchRmApi = async (params: searchRmProps) => {
  const res = await api({
    method: "post",
    url: `roomResv/searchRm`,
    data: params,
  });

  return res;
};

//객실상품상세정보 조회
export const rmPdDtlApi = async ({ rmPdNo }: { rmPdNo: string }) => {
  const res = await api({
    method: "get",
    url: `roomResv/rmPdDtlInfo/${rmPdNo}`,
  });

  return res;
};

//예약가능 리스트
export const resvPdApi = async (params: resvPdProps) => {
  const res = await api({
    method: "post",
    url: `roomResv/resvPsbPdList`,
    data: params,
  });

  return res;
};

//객실별옵션상품 검색
export const rmOpApi = async (params: rmOpProps) => {
  const res = await api({
    method: "post",
    url: `roomResv/searchRmOpPdList`,
    data: params,
  });

  return res;
};

//객실예약
export const resvRmApi = async (params: resvRmProps) => {
  const res = await api({
    method: "post",
    url: `roomResv/resvRm`,
    data: params,
  });

  return res;
};

/**
 * 다객실
 */

//객실정보 조회 _ 다객실
export const searchRmMultiApi = async (params: searchRmProps) => {
  const res = await api({
    method: "post",
    url: `roomResvMulti/searchRm`,
    data: params,
  });

  return res;
};

//객실선택 _ 다객실 선택 시 금액 계산
export const selRmListApi = async (params: selRmListProps) => {
  const res = await api({
    method: "post",
    url: "roomResvMulti/selRmList",
    data: params,
  });

  return res;
};

//객실예약_다객실 선택
export const resvMultiRmApi = async (params: IResvMultiRm) => {
  const res = await api({
    method: "post",
    url: "roomResvMulti/resvRm",
    data: params,
  });

  return res;
};
